export const contact = {
  emailAddress: "zer.dance@gmail.com",
  title: {
    ja: "お問い合わせについて",
    en: "Contact",
  },
  body: {
    ja:
      "ワークショップ、作品提供などのご依頼は以下メールアドレスにて受け付けております。その他、ご質問などございましたら、お気軽にご連絡ください。",
    en:
      "Requests for workshops, artworks, and performances can be sent to the following email address.\nIf you have any other questions, please feel free to contact us.",
  },
  email: {
    subject: {
      ja: "zer◯：お問い合わせ",
      en: "zer◯: Form",
    },
    body: {
      ja: "こちらにお問い合わせ内容を入力してください。",
      en: "Please fill in what you'd like to ask for.",
    },
  },
};
